import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * User display preferences that persist across sessions (per browser).
 *
 * Kept separate from the ephemeral `ui` slice (toasts/modals/loading) so it can
 * be persisted without dragging transient UI state into storage.
 */
export type TimeFormat = '12h' | '24h';

export interface PreferencesState {
  /** How time-of-day is rendered app-wide. Product default is 12-hour. */
  timeFormat: TimeFormat;
}

const initialState: PreferencesState = {
  timeFormat: '12h',
};

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    /** Switch the app-wide time display between 12- and 24-hour. */
    setTimeFormat: (state, action: PayloadAction<TimeFormat>) => {
      state.timeFormat = action.payload;
    },
  },
});

export const { setTimeFormat } = preferencesSlice.actions;
export const preferencesReducer = preferencesSlice.reducer;

/** Reads the current time-format preference (defaults to 12h). */
export const selectTimeFormat = (state: { preferences: PreferencesState }): TimeFormat =>
  state.preferences.timeFormat;
